import {Outlet, matchPath, useLocation, useNavigate} from "react-router-dom";
import Loader from "../components/loader";


import { useRecoilState } from "recoil";
import {
    bottomBarState,
    loaderState,
    navbarTitleState,
    showBottomBarState,
    showNavbarState,
    userState
} from "../states/common";
import {useEffect} from "react";
import BottomBar from "../components/bottomBar";
import toast from "react-hot-toast";
import * as SBService from "../helpers/sportbookService";
import * as _ from "lodash";
import {getAssetFullUrl} from "../helpers/utils";
import GlobalNotification from "../components/GlobalNotification";
import {setAnalyticsUser} from "../helpers/analytics";
import GlobalErrorNotification from "../components/GlobalErrorNotification";
import SwissChallengeNotification from "../components/SwissChallengeNotification";
import PushForeground from "../components/PushForeground";

/**
 * Các trang dưới Layout mở cho khách chưa đăng nhập.
 *
 * Mọi đường khác vẫn cần token — đăng ký giải, hồ sơ, quét QR, nhập kết quả.
 * Khớp bằng matchPath chứ không phải startsWith: '/league/:id' là công khai còn
 * '/league/:id/detail' thì không, mà cái sau bắt đầu bằng cái trước.
 */
const PUBLIC_PATHS = [
    "/",
    "/bxh",
    "/live",
    "/league",
    "/league-end",
    // Chi tiết giải phải mở, vì đó là nơi khách bấm "Đăng nhập để tham gia".
    // Các màn sau đăng ký (/detail, /history, lịch playoff, nhập kết quả) vẫn
    // cần token — chúng gọi những API chưa có bản công khai.
    "/league/:id",
];

export const isPublicPath = (pathname: string) =>
    PUBLIC_PATHS.some((path) => !!matchPath({path, end: true}, pathname));

const Layout = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [loader, setLoader] = useRecoilState(loaderState)
    const [navbarTitle , setNavbarTitle] = useRecoilState(navbarTitleState)
    const [showNavbar , setShowNavbar] = useRecoilState(showNavbarState)
    const [showBottomBar , setBottomBar] = useRecoilState(showBottomBarState)
    const [user , setUser] = useRecoilState(userState)


    const hasToken = !!localStorage.getItem('token')
    const publicPage = isPublicPath(location.pathname)

    /* Chuyển bằng replace chứ không push: trang bị chặn không được nằm lại trong
       lịch sử, nếu không nút "Quay lại" ở màn đăng nhập sẽ đưa về đúng trang đó
       rồi bị đá về login lần nữa — một vòng lặp.
       Khách bấm sang trang cần đăng nhập thì mới chặn. Guard phải chạy lại theo
       đường dẫn: Layout không remount khi điều hướng trong cùng vỏ, nên để trong
       effect khởi tạo là đi từ trang chủ sang /profile không bị chặn gì cả. */
    useEffect(() => {
        if (!localStorage.getItem('token') && !isPublicPath(location.pathname)) {
            navigate('/auth/login', {replace: true})
        }
    }, [location.pathname])

    useEffect(() => {
        setLoader(false)

        const loadUser = async () => {
            try {
                let dataProFile
                const rsp = await SBService.myProfile()
                dataProFile = rsp
                if(rsp.data){
                    dataProFile = rsp.data
                }
                if (dataProFile){                                        
                    if(dataProFile.profilePicture) {                        
                        if (dataProFile.profilePicture.indexOf('https') === -1) {
                            dataProFile.profilePicture = getAssetFullUrl(dataProFile.profilePicture)
                        }
                    } else {
                        dataProFile.profilePicture = 'https://placehold.co/96x96'
                    }
                    setUser(dataProFile)
                    setAnalyticsUser(dataProFile.id)
                    // JSON.stringify, not the object: localStorage coerces a
                    // non-string to "[object Object]", and leagueMatching.tsx and
                    // leagueMatchingConfirmResult.tsx both JSON.parse this value —
                    // which threw on every match page opened by direct URL, surfacing
                    // as "Không tìm thấy đối thủ trong giải đấu".
                    localStorage.setItem('userInfo', JSON.stringify(dataProFile))
                    setLoader(false)
                } else {
                    // Không có hồ sơ tức là token không còn ứng với tài khoản nào.
                    localStorage.removeItem('token')
                    localStorage.removeItem('userInfo')
                    // Trang công khai thì xem tiếp với tư cách khách, đá ra màn
                    // đăng nhập chỉ vì token cũ là mất trang đang đọc.
                    if (!isPublicPath(location.pathname)) {
                        navigate('/auth/login', {replace: true})
                    }
                    setLoader(false)
                }
            } catch (e: any) {
                // /players/me là lời gọi duy nhất đủ tư cách phán "phiên đã chết":
                // 401 ở đây nghĩa là token không còn dùng được. Xoá token và nói rõ
                // lý do, thay vì đẩy về màn đăng nhập mà người dùng không hiểu vì sao.
                // Các 401 lẻ ở API khác KHÔNG được coi là hết hạn phiên - từng thử
                // bắt tập trung và nó đá người dùng ra ngay sau khi đăng nhập.
                if (e?.response?.status === 401) {
                    localStorage.removeItem('token')
                    localStorage.removeItem('userInfo')
                    toast.error('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại.')
                }
                if (!isPublicPath(location.pathname)) {
                    navigate('/auth/login', {replace: true})
                }
                setLoader(false)
            }
        }  
              
        // Không có token thì không gọi /players/me: khách vẫn xem được trang.
        if (hasToken && user && !user.id) {
            setLoader(true)
            loadUser()
        }
    }, [])




    return (
        <div className="main app-shell px-5 relative top-0">
            {/* Có token thì chờ tải xong hồ sơ rồi hãy vẽ (tránh chớp nội dung
                rỗng); khách thì vẽ ngay ở các trang công khai. */}
            {user.id || (!hasToken && publicPage) ? <Outlet /> : <></>}
            <GlobalNotification/>
            <GlobalErrorNotification/>
            <SwissChallengeNotification/>
            <PushForeground/>
            {showBottomBar ?  <BottomBar/> : <></>}
            {loader ? <Loader/> : <div/>}
        </div>
    )
};

export default Layout;